"use strict";

exports.__esModule = true;
exports.MachineStateCountFields = MachineStateCountFields;
var _core = require("@blueprintjs/core");
var _react = _interopRequireDefault(require("react"));
var _Translator = require("../../Core/Translator");
var _PlantStateActivities = require("../../PlantStateActivities");
var _MachineStateCountHelpers = require("./MachineStateCountHelpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DEFAULT_LABEL_SIZE = 0.2;

/**
 * Fields for MachineStateCountElement.
 */
function MachineStateCountFields(_ref) {
  var element = _ref.element,
    path = _ref.path,
    elementEditor = _ref.elementEditor;
  return /*#__PURE__*/_react["default"].createElement(_Translator.Translator, null, function (_ref2) {
    var translate = _ref2.translate;
    return /*#__PURE__*/_react["default"].createElement(_PlantStateActivities.PlantStateActivitiesContext.Consumer, null, function (plantStateActivities) {
      var _element$props$labelS;
      var states = (0, _MachineStateCountHelpers.getStateSelectorItems)(plantStateActivities, translate);
      var selected = states.filter(function (state) {
        return state.id === element.props.stateId;
      });
      var hasState = Boolean(element.props.stateId);
      var showOtherDevices = Boolean(element.props.showOtherDevices);
      var showTotalDevices = Boolean(element.props.showTotalDevices);
      var separatorAvailable = hasState && showTotalDevices && !showOtherDevices;
      var hideLabel = Boolean(element.props.hideLabel);
      var labelSizePercent = Math.round(((_element$props$labelS = element.props.labelSize) != null ? _element$props$labelS : DEFAULT_LABEL_SIZE) * 100);
      var totalSeparator = (0, _MachineStateCountHelpers.resolveTotalSeparator)(element.props);
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
        label: translate("MachineStateCountFields.state.label", "State")
      }, /*#__PURE__*/_react["default"].createElement(_PlantStateActivities.PlantStateSelector, {
        items: states,
        selected: selected,
        getItemCategory: _MachineStateCountHelpers.getStateSelectorItemCategory,
        getCategoryTitle: function getCategoryTitle() {
          return undefined;
        },
        onSelect: function onSelect(nextSelected) {
          var _nextSelected$;
          return elementEditor.setProp(path, "stateId", (_nextSelected$ = nextSelected[0]) == null ? void 0 : _nextSelected$.id);
        }
      })), /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
        checked: showOtherDevices,
        disabled: !hasState,
        label: translate("MachineStateCountFields.showOtherDevices.label", "Show other devices"),
        onChange: function onChange(event) {
          return elementEditor.setProp(path, "showOtherDevices", event.target.checked);
        }
      }), /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
        checked: showTotalDevices,
        disabled: !hasState,
        label: translate("MachineStateCountFields.showTotalDevices.label", "Show total device number"),
        onChange: function onChange(event) {
          return elementEditor.setProp(path, "showTotalDevices", event.target.checked);
        }
      }), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
        label: translate("MachineStateCountFields.totalSeparator.label", "Count / total separator"),
        helperText: translate("MachineStateCountFields.totalSeparator.helperText", 'Text between count and total when total is shown, e.g. " of ", " / ", or " - ".')
      }, /*#__PURE__*/_react["default"].createElement(_core.InputGroup, {
        value: separatorAvailable ? totalSeparator : "",
        disabled: !separatorAvailable,
        placeholder: " of ",
        onChange: function onChange(event) {
          return elementEditor.setProp(path, "totalSeparator", event.target.value);
        }
      })), /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
        checked: hideLabel,
        label: translate("MachineStateCountFields.hideLabel.label", "Hide Label"),
        onChange: function onChange(event) {
          return elementEditor.setProp(path, "hideLabel", event.target.checked);
        }
      }), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
        label: translate("MachineStateCountFields.labelSize.label", "Label size"),
        helperText: translate("MachineStateCountFields.labelSize.helperText", "Share of the widget height used for the label. Larger labels make the value smaller.")
      }, /*#__PURE__*/_react["default"].createElement(_core.Slider, {
        min: 10,
        max: 40,
        stepSize: 1,
        labelStepSize: 10,
        value: labelSizePercent,
        disabled: hideLabel,
        onChange: function onChange(value) {
          return elementEditor.setProp(path, "labelSize", value / 100);
        },
        labelRenderer: function labelRenderer(value) {
          return value + "%";
        }
      })));
    });
  });
}